import { Box, Card, CardContent } from "@mui/material"
import { StaticImageData } from "next/image"
import { MouseEvent } from "react"
import styles from "./CounterCard.module.css"

interface requestStatusCardProps {
  className?: string
  bgImage: string | StaticImageData
  title: string
  selected: boolean
  requestCount: any
  onCardClick?: () => void
  onLabelClick?: () => void
  onCountClick?: () => void
}

const CounterCards = ({ className, bgImage, title, selected, requestCount, onCardClick, onLabelClick, onCountClick }: requestStatusCardProps) => {
  const onParentCountClick = (e: MouseEvent) => {
    e.stopPropagation()
    if (typeof onCountClick === "function") onCountClick()
  }

  return (
    <Card
      className={`${styles.CardRoot} ${selected ? styles.Selected : ""} ${className}`}
      sx={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
      onClick={onCardClick}
    >
      <CardContent className={styles.CardContent}>
        <Box
          className={styles.CardContentBox}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "-10px", // Cover White Space Below Due to Font
          }}
        >
          <Box className={styles.Title} onClick={onLabelClick}>
            {title}
          </Box>
          <Box
            sx={{
              cursor: typeof onCountClick === "function" ? "pointer" : "default",
            }}
            className={styles.Count}
            onClick={onParentCountClick}
          >
            {requestCount}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default CounterCards
